import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

export const getIncomingApplications = createAsyncThunk(
  "getIncomingApplications",
  async (applicationStatus) => {
    const bearerToken = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/company?auditStatus=${applicationStatus}&stage=CERTIFIER`,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

// RC Extension API
export const getRcExtensionApplications = createAsyncThunk(
  "getRcExtensionApplications",
  async (applicationStatus) => {
    const bearerToken = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/cui-application-form/scope-extension?status=${applicationStatus}&stage=CERTIFIER`,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

// RC Renewal API
export const getRcRenewalApplications = createAsyncThunk(
  "getRcRenewalApplications",
  async (applicationStatus) => {
    const bearerToken = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/cui-application-form?status=${applicationStatus}&renewal=true&stage=CERTIFIER`,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getIncomingApplicationById = createAsyncThunk(
  "getIncomingApplicationById",
  async (applicationId) => {
    const bearerToken = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/company/${applicationId}`,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getIncomingRenewApplicationById = createAsyncThunk(
  "getIncomingRenewApplicationById",
  async (applicationId) => {
    const bearerToken = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/cui-application-form/${applicationId}`,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getIncomingExApplicationById = createAsyncThunk(
  "getIncomingExApplicationById",
  async (applicationId) => {
    const bearerToken = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/cui-application-form/scope-extension/${applicationId}`,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getCount = createAsyncThunk("getCount", async () => {
  const bearerToken = localStorage.getItem("cu_user");
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_HOST}/api/company/agg-status/count`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );

    return data.data;
  } catch (error) {
    console.error(error);
  }
});

//"assign to me button action"
export const postAssignToMe = createAsyncThunk(
  "postAssignToMe",
  async ({ companyId, applicationRenewStatus }) => {
    const bearerToken = localStorage.getItem("cu_user");
    return toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          let url;
          if (applicationRenewStatus === "old") {
            url = `${process.env.REACT_APP_API_HOST}/api/company/self-assign/${companyId}`;
          } else if (applicationRenewStatus === "extension") {
            url = `${process.env.REACT_APP_API_HOST}/api/cui-application-form/scope-extension/assign/${companyId}`;
          } else {
            url = `${process.env.REACT_APP_API_HOST}/api/cui-application-form/self-assign/${companyId}`;
          }
          let response;
          if (applicationRenewStatus === "extension") {
            response = await axios.post(
              url,
              {},
              {
                headers: {
                  Authorization: `Bearer ${bearerToken}`,
                },
              }
            );
          } else {
            response = await axios.patch(
              url,
              {},
              {
                headers: {
                  Authorization: `Bearer ${bearerToken}`,
                },
              }
            );
          }

          if (response.data.status === "success") {
            resolve(response);

            return response?.data;
          } else {
            reject(response?.data?.message);
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Assigning...",
        success: "Assigned to you successfully",
        error: {
          render({ data }) {
            return `${data?.message}`;
          },
        },
      }
    );
  }
);

export const approveApplication = createAsyncThunk(
  "approveApplication",
  async ({ id, values, type }) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        const bearerToken = localStorage.getItem("cu_user");
        try {
          let url;
          if (type === "old") {
            url = `${
              process.env.REACT_APP_API_HOST
            }/api/company/company-approve/${encodeURIComponent(id)}`;
          } else {
            url = `${
              process.env.REACT_APP_API_HOST
            }/api/cui-application-form/flow/v2/approve/${type}/${encodeURIComponent(
              id
            )}`;
          }
          let res;
          if (type === "old") {
            res = await axios.patch(url, values, {
              headers: {
                Authorization: `Bearer ${bearerToken}`,
              },
            });
          } else {
            res = await axios.post(url, values, {
              headers: {
                Authorization: `Bearer ${bearerToken}`,
              },
            });
          }

          if (res?.data?.status === "success") {
            resolve(res);
            return res?.data;
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Approving...",
        success: "Application approved successfully",
        error: {
          render({ data }) {
            return `${data?.message}`;
          },
        },
      }
    );
  }
);

export const rejectApplication = createAsyncThunk(
  "rejectApplication",
  async ({ id, values, type }) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        const bearerToken = localStorage.getItem("cu_user");
        try {
          let url;
          if (type === "old") {
            url = `${
              process.env.REACT_APP_API_HOST
            }/api/company/company-reject/${encodeURIComponent(id)}`;
          } else {
            url = `${
              process.env.REACT_APP_API_HOST
            }/api/cui-application-form/flow/v2/reject/${type}/${encodeURIComponent(
              id
            )}`;
          }
          let res;
          if (type === "old") {
            res = await axios.patch(url, values, {
              headers: {
                Authorization: `Bearer ${bearerToken}`,
              },
            });
          } else {
            res = await axios.post(url, values, {
              headers: {
                Authorization: `Bearer ${bearerToken}`,
              },
            });
          }

          if (res?.data?.status === "success") {
            resolve(res);
            return res?.data;
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Processing...",
        success: "Application rejected successfully",
        error: {
          render({ data }) {
            return `${data?.message}`;
          },
        },
      }
    );
  }
);

//move to planner
export const moveToPlanner = createAsyncThunk(
  "moveToPlanner",
  async ({ companyId, values, type }) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        const bearerToken = localStorage.getItem("cu_user");
        try {
          let url;
          if (type === "old") {
            url = `${
              process.env.REACT_APP_API_HOST
            }/api/audit/moveToPlanning/${encodeURIComponent(companyId)}`;
          } else {
            url = `${
              process.env.REACT_APP_API_HOST
            }/api/cui-application-form/flow/v2/moveToPlanning/${type}/${encodeURIComponent(
              companyId
            )}`;
          }
          let res;
          if (type === "old") {
            res = await axios.patch(url, values, {
              headers: {
                Authorization: `Bearer ${bearerToken}`,
              },
            });
          } else {
            res = await axios.post(url, values, {
              headers: {
                Authorization: `Bearer ${bearerToken}`,
              },
            });
          }

          if (res?.data?.status === "success") {
            resolve(res);
            return res?.data;
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Processing...",
        success: "Application moved to planner successfully",
        error: {
          render({ data }) {
            return `${data?.message}`;
          },
        },
      }
    );
  }
);

//move to auditor (move to pending)
export const moveToAuditor = createAsyncThunk(
  "moveToPlanner",
  async ({ unitId, values }) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        const bearerToken = localStorage.getItem("cu_user");
        try {
          const res = await axios.patch(
            `${process.env.REACT_APP_API_HOST}/api/audit/moveToPending/${unitId}`,
            values,
            {
              headers: {
                Authorization: `Bearer ${bearerToken}`,
              },
            }
          );
          if (res?.data?.status === "success") {
            resolve(res);
            return res?.data;
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "processing...",
        success: "Audit moved to Auditor Successfully",
        error: {
          render({ data }) {
            return `${data?.message}`;
          },
        },
      }
    );
  }
);

export const CertifierSlice = createSlice({
  name: "certifier",
  initialState: {
    incomingApplications: [],
    rcExtensionApplications: [],
    rcRenewalApplications: [],
    application: null,
    counts: [],
    status: "idle",
    isloading: true,
    error: null,
    exApplication: null,
    renewApplication: null,
  },
  reducers: {},
  extraReducers: {
    [getIncomingApplications.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getIncomingApplications.fulfilled]: (state, action) => {
      state.status = "success";
      state.incomingApplications = action.payload;
      state.isloading = false;
    },
    [getIncomingApplications.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = false;
    },
    [getIncomingExApplicationById.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getIncomingExApplicationById.fulfilled]: (state, action) => {
      state.exApplication = action.payload;
      state.status = "success";
      state.isloading = false;
    },
    [getIncomingExApplicationById.rejected]: (state, action) => {
      state.error = action.error;
      state.status = "failed";
      state.isloading = false;
    },
    [getRcExtensionApplications.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getRcExtensionApplications.fulfilled]: (state, action) => {
      state.status = "success";
      state.rcExtensionApplications = action.payload;
      state.isloading = false;
    },
    [getRcExtensionApplications.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = false;
    },

    // RC Renewal
    [getRcRenewalApplications.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getRcRenewalApplications.fulfilled]: (state, action) => {
      state.status = "success";
      state.rcRenewalApplications = action.payload;
      state.isloading = false;
    },
    [getRcRenewalApplications.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = false;
    },
    [getIncomingApplicationById.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getIncomingApplicationById.fulfilled]: (state, action) => {
      state.application = action.payload;
      state.status = "success";
      state.isloading = false;
    },
    [getIncomingApplicationById.rejected]: (state, action) => {
      state.error = action.error;
      state.status = "failed";
      state.isloading = false;
    },
    [getIncomingRenewApplicationById.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getIncomingRenewApplicationById.fulfilled]: (state, action) => {
      state.renewApplication = action.payload;
      state.status = "success";
      state.isloading = false;
    },
    [getIncomingRenewApplicationById.rejected]: (state, action) => {
      state.error = action.error;
      state.status = "failed";
      state.isloading = false;
    },
    [getCount.pending]: (state, action) => {
      state.status = "pending";
    },
    [getCount.fulfilled]: (state, action) => {
      state.counts = action.payload;
      state.status = "success";
    },
    [getCount.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
    },
    // [postAssignToMe.pending]: (state) => {
    //   state.status = "pending";
    // },
    // [postAssignToMe.fulfilled]: (state) => {
    //   state.status = "success";
    // },
    // [postAssignToMe.rejected]: (state, action) => {
    //   state.status = "failed";
    //   state.error = action.error;
    // },
  },
});

export default CertifierSlice.reducer;
